/** * ダッシュボードコンポーネント */
<template>
  <b-container id="the-dashboard">
    <b-row
      class="container-dashboard"
      v-bind:class="{ 'schedule-unavailable': !isScheduleAvailable }"
    >
      <div class="spacer" />
      <div class="view-schedule">
        <schedule v-if="isScheduleAvailable" />
      </div>
      <div class="view-information">
        <information
          class="information"
          v-if="isInformationAvailable"
          v-bind:class="{ 'timeline-unavailable': !isTimelineAvailable }"
        />
        <timeline
          class="timeline"
          v-if="isTimelineAvailable"
          v-bind:class="{ 'information-unavailable': !isInformationAvailable }"
        />
      </div>
      <div class="spacer" />
    </b-row>
  </b-container>
</template>

<script>
import schedule from '@/components/schedule/AppSchedule.vue'
import timeline from '@/components/AppTimeLine.vue'
import information from '@/components/AppInformation.vue'
import { FUNCTION_TYPE } from '@/constants.js'

export default {
  name: 'TheDashBoard',
  components: {
    schedule,
    timeline,
    information,
  },
  computed: {
    /**
     * スケジュールが利用可能か？
     * @type {Boolean}
     */
    isScheduleAvailable: function () {
      return !!this.$store.getters.functionType(FUNCTION_TYPE.SCHEDULE)
    },
    /**
     * タイムラインが利用可能か？
     * @type {Boolean}
     */
    isTimelineAvailable: function () {
      return !!this.$store.getters.functionType(FUNCTION_TYPE.TIMELINE)
    },
    /**
     * お知らせが利用可能か？
     * @type {Boolean}
     */
    isInformationAvailable: function () {
      return !!this.$store.getters.functionType(FUNCTION_TYPE.INFORMATION)
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../assets/scss/parts/container';

$-information-height: 25%;
$-information-min-height: 170px;
$-margin-vertical: 15px;

#the-dashboard {
  height: 100%;
  background-color: #f2f3f4;
}

.container-dashboard {
  margin: 0 !important;
  padding: 15px 0 0 0;
  height: 100%;
  display: grid;
  grid-template-rows: 100%;
  grid-template-columns: 0.5fr 500px 800px 0.5fr;

  &.schedule-unavailable {
    grid-template-columns: 0.5fr 0px 800px 0.5fr;
  }
}
@media screen and (max-width: 1300px) {
  .container-dashboard {
    grid-template-columns: 0px 500px 1fr 0px;

    &.schedule-unavailable {
      grid-template-columns: 0.5fr 0px 800px 0.5fr;
    }
  }
}

.view-schedule {
  height: 100%;
}

.view-information {
  height: 100%;
  padding-left: 15px;
  .schedule-unavailable & {
    padding-left: 0;
  }
}

.information {
  margin-bottom: $-margin-vertical;
  height: calc(max(#{$-information-height}, #{$-information-min-height}));

  &.timeline-unavailable {
    margin-bottom: 0;
    height: 100%;
  }
}

.timeline {
  $-information-height-actual: calc(
    max(#{$-information-height}, #{$-information-min-height})
  );
  height: calc(100% - #{$-information-height-actual} - #{$-margin-vertical});

  &.information-unavailable {
    height: 100%;
  }
}
</style>
